var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',_vm._l((_vm.metadata),function(val,propName){return _c('b-col',{staticClass:"mb-3",attrs:{"lg":_vm.cols(val)}},[_c('label',{staticClass:"text-truncate"},[_vm._v(_vm._s(_vm.humanPropName(propName)))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(val))])])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }